const ERROR_CODE = {
  UNDER_MAINTENANCE: "503_UNDER_MAINTENANCE",
} as const

export default ERROR_CODE
